export default __webpack_public_path__ + "static/media/online-banking.ea1f1942.svg";